import { Tooltip as T } from "radix-ui";
import type { ReactNode } from "react";

export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <T.Provider delayDuration={350} skipDelayDuration={200}>
      {children}
    </T.Provider>
  );
}

export function Tooltip({
  label,
  children,
  side = "top",
  shortcut,
  disabled,
}: {
  label: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  shortcut?: string;
  disabled?: boolean;
}) {
  if (disabled || !label) return <>{children}</>;
  return (
    <T.Root>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content
          side={side}
          sideOffset={6}
          collisionPadding={8}
          className="z-[100] flex items-center gap-2 rounded-md bg-surface-3 px-2 py-1 text-xs font-medium text-fg shadow-pop animate-fade-in select-none"
        >
          {label}
          {shortcut && <kbd className="rounded-sm bg-surface px-1 font-sans text-[11px] leading-4 text-fg-3">{shortcut}</kbd>}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
